import React, { useState } from "react";
import "./loginPage.scss";
import { RiHome2Fill } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { LiaQrcodeSolid } from "react-icons/lia";
import pgimage from "../../img/mobile.jpg";

const Register = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleStRegister = async (e) => {
    e.preventDefault();

    if (!fullName || !password || !email) {
      setErrorMsg("Need to fill all fields");
      return;
    }

    setErrorMsg("");

    if (password !== rePassword) {
      setErrorMsg("Passwords do not match");
      return;
    }

    setLoading(true);
    const data = {
      fullName,
      email,
      password,
    };
    try {
      await axios.post("/admin-register", data);
      navigate("/");
    } catch (error) {
      return;
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-right">
        <div className="logo">
          <img src={require("../../img/logo.png")} alt="" />

        </div>
        <form className="login-form" onSubmit={handleStRegister}>
          <div className="log_hed">
            <h2>Register</h2>
            {/* <h5>Teacher Portal</h5> */}
          </div>

          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              va
              placeholder="Enter Full Name"
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="text"
              placeholder="Enter Email"
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter Password"
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={rePassword}
              onChange={(e) => setRePassword(e.target.value)}
              placeholder="Re-enter Password"
            />
          </div>
          {loading ? (
            <button className="btn">Please wait...</button>
          ) : (
            <button type="submit" className="btn">
              Register
            </button>
          )}

          {errorMsg && (
            <small
              style={{ fontSize: "10px", color: "red", marginTop: "10px" }}
            >
              {errorMsg}
            </small>
          )}
        </form>
        <div className="copy_right">
          <small>Copyright © intellitech.ae. All Rights Reserved.</small>
        </div>
      </div>
      <div
        className="login-left"
        style={{
          backgroundImage: `url(${pgimage})`,
          backgroundSize: "cover",
          backgroundPosition: "left",
          objectFit: "contain",
        }}
      >
   
      </div>
    </div>
  );
};

export default Register;
